import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { usePaymentsAccount } from '../../Data/Payments';
import { PageLoading } from '../../Components/Loading';
import Setup from './Setup';
import Main from './Main';

const Payments = () => {
    const {account} = usePaymentsAccount();

    if (!account) {
        return <>
            <TopBar title="Payments" />
            <Page zeroPad>
                <PageLoading />
            </Page>
        </>
    }

    if (account?.setupProgress?.completed !== true) {
        return <Setup />
    }

    return <Main account={account} />
}

export default Payments;
